<template>
  <article
      :id="moment.urlSegment"
      :class="['epoch__item', 'epoch__item--moment', moment.illustration, `epoch__item--${trimmedWindowType}`]"
  >
    <div class="epoch__content moment">
      <div :class="['timeline-window', moment.windowType]">
        <div :class="['timeline-window__view', moment.view]">
          <figure
              v-if="moment.imageHtml"
              class="timeline-window__media"
              v-html="moment.imageHtml"
          ></figure>
          <div
              v-else
              class="timeline-window__media site-page-partial__no-image-container"
          >
            <span class="site-page-partial__no-image-container-graphic"></span>
          </div>
          <div class="image-overlay"/>
        </div>

        <div
            v-if="moment.windowType == 'timeline-window--early-1900'"
            class="window-top"
        ></div>
        <div
            v-if="moment.windowType == 'timeline-window--early-1900'"
            class="window-bottom"
        ></div>
      </div>
      <div class="moment__header">
        <h2>{{ moment.year }}</h2>
        <div>{{ moment.title }}</div>
      </div>
      <div class="moment__excerpt">{{ moment.momentExcerpt }}</div>
      <button class="moment__button" @click.prevent="showModal"><span class="sr-only">Open more information</span></button>
    </div>
  </article>
</template>

<script lang="ts" setup>
import { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";
import { useElementInViewportService } from "../../services/jvm/elementInViewportService";
import { onMounted } from "vue";
import { useTimelineMapStore } from "../../store/timelineMapStore";
import { useTimelineMapService } from "../../services/timelineMapService";


const { trimWindowTypes } = useTimelineMapService();
const store = useTimelineMapStore();
const props = defineProps<{ moment: ITimelineMapItem }>()
const trimmedWindowType = trimWindowTypes(props.moment.windowType);

const showModal = () => {
  store.onShowModal(props.moment);
}

onMounted(() => {
  useElementInViewportService('timeline', props.moment.urlSegment, !!props.moment.urlSegment);
});
</script>
